import { PolygonLayer, LayerEvent, MapScene, Control, ColorComponent, Popup } from '@antv/l7-react';
import React, { useEffect, useState } from 'react';
import { usePapaParse } from 'react-papaparse';
import { Box } from "@mui/system";

import DownloadButton from "../Common/DownloadButton";

const ChapterOneMap = (props) => {


    const [data, setData] = useState([]);
    const csv = props.csv;
    const { readString } = usePapaParse();
    const [hovered, setHovered] = useState(undefined);
    const [max, setMax] = useState(undefined);

    const [countrySelectStatus, setCountrySelectStatus] = useState({ selected: false, country: undefined })

    const handleReadString = () => {
        readString(csv, {
            complete: (results, file) => {
                props.json.features.map(j => {
                    let sum = 0;
                    results.data.filter(d => d['Country'] === j.properties['NAME']).forEach(f => {
                        sum += f['Samples'];
                    })
                    j.properties = { ...j.properties, sum }
                    return j;
                });
                setData({ json: props.json, conv: results.data });
                setMax(Math.max(...props.json.features.map(f => f.properties.sum)));
            },
            download: true,
            header: true,
            dynamicTyping: true,
            error: (error, file) => {
                console.log('Error while parsing:', error, file);
            },
        });
    };

    useEffect(() => {
        handleReadString();
    }, []);

    const [canvas, setCanvas] = useState(undefined);

    const getTooltipContent = (country) => {
        const found = data.conv.find(d => d['Country'] === country);
        if (!found) {
            <div className='tooltipWrapper' style={{ padding: '.5rem', wordWrap: 'break-word' }}>
                Number of samples: 0
            </div>
        }
        const content = data.conv.filter(d => d['Country'] === country);
        const sum = content.map(c => c['Samples']).reduce((partialSum, a) => partialSum + a, 0);
        return (
            <div className='tooltipWrapper' style={{ padding: '.5rem', wordWrap: 'break-word' }}>
                Number of samples: {sum}
            </div>
        );
    };
    const colors = ['#fff', '#CBDDEE', '#98BDDF', '#72A5D3', '#5894CB', '#2574BB', '#246898'];

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
    useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth <= 900)
        }
        window.addEventListener('resize', handleResize)
        return _ => {
            window.removeEventListener('resize', handleResize)
        }
    })
    useEffect(() => {
        const canvases = document.getElementsByClassName('l7-marker-container');
        for (let i = 0; i < canvases.length; i++) {
            canvases[i].onwheel = function (event) {
                event.stopPropagation();
            };
        }
    });

    return (
        <Box>
            <Box display='flex' justifyContent='flex-end'>
                {data.conv &&
                    <div style={{ fontFamily: 'Roboto Condensed, sans-serif', minWidth: isMobile ? '250px' : '300px' }}>

                        <ColorComponent items={[
                            { title: '0', color: '#CBDDEE' },
                            { title: Math.round(max * 0.1), color: '#98BDDF' },
                            { title: Math.round(max * 0.3), color: '#72A5D3' },
                            { title: Math.round(max * 0.5), color: '#5894CB' },
                            { title: Math.round(max * 0.6), color: '#2574BB' },
                            { title: Math.round(max), color: '#246898' },
                        ]} />
                    </div>
                }
                <DownloadButton isMap canvas={canvas} fileName='Map' csv={data.conv} />
            </Box>

            {data.json && <MapScene
                onSceneLoaded={(scene) => {
                    setCanvas(scene);
                }}
                autoFit
                map={{
                    pitch: 0,
                    style: 'blank',
                    zoom: 2,
                    minZoom: 2,
                    maxZoom: 4,
                    center: [112, 30],

                }}
                style={{
                    height: '500px',
                    position: 'relative',
                }}
            >
                <PolygonLayer
                    key={2}
                    source={{
                        data: data.json
                    }}
                    color={{
                        field: 'sum',
                        values: (d) => {
                            if (d === 0) {
                                return colors[0];
                            } else if (d > 0 && d <= max * 0.1) {
                                return colors[1];
                            } else if (d > max * 0.1 && d <= max * 0.3) {
                                return colors[3];
                            } else if (d > max * 0.3 && d <= max * 0.5) {
                                return colors[4];
                            } else if (d > max * 0.5 && d <= max * 0.6) {
                                return colors[5];
                            } else {
                                return colors[6];
                            }
                        }
                    }}
                    options={{
                        autoFit: true,
                    }}
                    size={{
                        values: 1,
                    }}
                    shape={{
                        values: 'fill',
                    }}
                    active={{
                        option: {
                            color: '#C6C2C2',
                        },
                    }}
                    select={{
                        option: {
                            color: '#C6C2C2',
                        },
                    }}
                >
                    {hovered && data.conv.find(d => d['Country'] === hovered.feature.properties.NAME) &&
                        <Popup option={{ stopPropagation: false }} lnglat={hovered?.lngLat}>
                            <div className="tooltipWrapper" style={{ padding: '.5rem' }}>
                                {<b>{hovered.feature.properties.NAME}</b>}
                                <br />
                                {getTooltipContent(hovered.feature.properties.NAME)}
                            </div>
                        </Popup>
                    }
                    <LayerEvent
                        type="click"
                        handler={e => {
                            const state = {
                                country: e.feature.properties['NAME'],
                                data: data.conv.filter(d => d['Country'] === e.feature.properties['NAME'])
                            };
                            setCountrySelectStatus(prevState => {
                                if (prevState.selected === true && prevState.country === e.feature.properties['NAME']) {
                                    // deselect
                                    props.onCountryClick(undefined);
                                    return { selected: false, country: undefined }
                                } else {
                                    props.onCountryClick(state);
                                    return { selected: true, country: e.feature.properties['NAME'] }
                                }

                            })
                        }}
                    ></LayerEvent>
                    <LayerEvent
                        type="mouseenter"
                        handler={e => {
                            setHovered(e);
                        }}
                    ></LayerEvent>
                    <LayerEvent
                        type="mouseout"
                        handler={e => {
                            setHovered(undefined);
                        }}
                    ></LayerEvent>
                </PolygonLayer>
                <PolygonLayer source={data.json}
                    key={1}
                    source={{
                        data: data.json,
                    }}
                    size={{
                        values: .5,
                    }}
                    color={{
                        values: '#C6C2C2',
                    }}
                    shape={{
                        values: 'line',
                    }}
                    style={{
                        opacity: 0.5,
                    }}
                />
                <Control type="scale" position="bottomright" />
                <Control type="zoom" position="bottomright" />
            </MapScene>
            }
        </Box>
    );
};

export default ChapterOneMap;
